import { FC } from 'react'

import { Box, Paper, Skeleton } from '@mui/material'

import { SectionCard } from '../SectionCard/SectionCard'
import { TableSkeleton } from '../TableSkeleton/TableSkeleton'

interface HeroAndTableSkeletonProps {
  /** Number of follow-up `SectionCard` blocks rendered after the hero. */
  sections?: number
}

/**
 * Placeholder for the "hero paper + supporting sections" detail dialogs —
 * Alignment, Blind Spot, Shared/Diverging motivations. Renders a tinted
 * hero block, then a configurable number of `SectionCard` placeholders ending
 * in a table.
 */
export const HeroAndTableSkeleton: FC<HeroAndTableSkeletonProps> = ({ sections = 2 }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
    <Paper variant="outlined" sx={{ p: 2.5, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Skeleton variant="text" width={160} height={18} />
      <Skeleton variant="text" width="70%" height={28} />
      <Skeleton variant="text" width="90%" />
      <Skeleton variant="text" width="80%" />
    </Paper>
    {Array.from({ length: sections }).map((_, i) =>
      i === sections - 1 ? (
        <TableSkeleton key={i} rows={6} columns={4} titleWidth={260} />
      ) : (
        <SectionCard key={i} title={<Skeleton variant="text" width={240} height={24} />}>
          <Skeleton variant="text" width="100%" />
          <Skeleton variant="text" width="85%" />
          <Skeleton variant="text" width="60%" />
        </SectionCard>
      )
    )}
  </Box>
)
